package fr.manyverse.app.presentation.components.modules.announcement

import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.Announcement
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import coil3.compose.AsyncImage
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.restore_announcement
import org.jetbrains.compose.resources.stringResource

@Composable
fun AnnouncementBubble(
    onClick: () -> Unit,
    imageUrl: String? = null,
    modifier: Modifier = Modifier
) {
    FloatingActionButton(
        onClick = onClick,
        containerColor = MaterialTheme.colorScheme.primaryContainer,
        modifier = modifier
    ) {
        if (imageUrl != null) {
            AsyncImage(
                model = imageUrl,
                contentDescription = stringResource(Res.string.restore_announcement),
                contentScale = ContentScale.Crop,
                modifier = Modifier
                    .size(56.dp)
                    .clip(RoundedCornerShape(16.dp))
            )
        } else {
            Icon(
                imageVector = Icons.AutoMirrored.Filled.Announcement,
                contentDescription = stringResource(Res.string.restore_announcement)
            )
        }
    }
}
